export const querySignRegexp = new RegExp(/\/?\?$/);
export const endingSlashRegexp = new RegExp(/\/$/);
export const beginigSlashRegexp = new RegExp(/^\/(?!\/)/);
export const beginigHashRegexp = new RegExp(/^#(?!$)/);
